<script setup lang="ts">
import type { ChatGroupProps } from "./chat.types";
import { useChatGroup } from "./useChatGroup";

defineOptions({ name: "EChatGroup" });

const props = defineProps<ChatGroupProps>();

const { classes, contentClasses, metaClasses, avatarClasses, showAvatar, showFrom, initials } = useChatGroup({
  props,
});
</script>

<template>
  <div :class="classes" class="e-chat-group" part="group">
    <!-- Avatar (left side only, when not disabled) -->
    <div v-if="showAvatar" :class="avatarClasses" part="avatar">
      <img v-if="avatar" :src="avatar" :alt="from" class="h-full w-full rounded-full object-cover" />
      <span v-else-if="initials">{{ initials }}</span>
    </div>

    <!-- Content column -->
    <div :class="contentClasses">
      <!-- Meta: sender name + time -->
      <div v-if="from || sentAt" :class="metaClasses" part="meta">
        <span v-if="showFrom" class="font-medium">{{ from }}</span>
        <span v-if="sentAt">{{ sentAt }}</span>
      </div>

      <!-- Bubble slot -->
      <slot />
    </div>
  </div>
</template>

<style>
:host {
  display: contents;
}
</style>
